
const state={
	nav:{
		anlixinshang:[],
		hexinyewu:[],
		lianxiwomen:[],
		xinwenzhongxin:[],
		zhudaohang:[],
		zoujinditan:[]
	}
}

const getters={
	getNav(){
		// state.nav.zhudaohang.push({
		// 	id: -1,
		// 	seo_description: '',
		// 	sub: [],
		// 	title: '加入我们',
		// 	url: '/join'
		// })
		return state.nav;
	},

}
const mutations={
	setNav(state,value){
		state.nav = value;
	},

}
const actions={

}
export default{
	state,
	getters,
	mutations,
	actions
}